export const webchatStyles = `
    * {
        font-family: "Inter var experimental", 
        "Inter var", -apple-system, BlinkMacSystemFont, 
        "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, 
        "Helvetica Neue", sans-serif; 
        font-variant-numeric: tabular-nums;
    }

    :host {
        all: initial;
        display: block !important;
        position: fixed !important;
        bottom: 0 !important;
        right: 0 !important;
        z-index: 2147483645 !important;
        width: auto !important;
        height: auto !important;
        overflow: visible !important;
        bottom: 70px !important;
        right: 20px !important;
    }
    
    * {
        box-sizing: border-box;
    }
    
    #webchat-shadow-container {
        display: block !important;
        position: relative !important;
        width: auto !important;
        height: auto !important;
    }
    
    body {
        margin: 0;
        font-family: "Inter var experimental", "Inter var", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    }
                
`;